// extracted by mini-css-extract-plugin
module.exports = {"trimText":"PodcastsEpisodes_trimText__HTl7U"};